module.exports = __webpack_public_path__ + "static/img/liBgImage2.cf65669.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/industryApplication/liBgImage2.png
// module id = p+mN
// module chunks = 7